/**
 * Chuyển command object (JS) -> Apple Plist XML.
 *
 * NanoMDM endpoint /v1/enqueue nhận NGUYÊN một plist command (không phải JSON).
 * Cấu trúc bắt buộc:
 *   <dict>
 *     <key>CommandUUID</key><string>...</string>
 *     <key>Command</key><dict> ...RequestType + tham số... </dict>
 *   </dict>
 */

/** Sinh command plist. Tự tạo CommandUUID nếu không truyền. */
export function buildCommandPlist(command, commandUUID) {
  const uuid = commandUUID || newUUID();
  return `<?xml version="1.0" encoding="UTF-8"?>
<!DOCTYPE plist PUBLIC "-//Apple//DTD PLIST 1.0//EN" "http://www.apple.com/DTDs/PropertyList-1.0.dtd">
<plist version="1.0">
<dict>
  <key>CommandUUID</key>
  <string>${escapeXml(uuid)}</string>
  <key>Command</key>
  <dict>${objectToPlist(command)}</dict>
</dict>
</plist>`;
}

function objectToPlist(obj) {
  return Object.entries(obj)
    .map(([k, v]) => `<key>${escapeXml(k)}</key>${valueToPlist(v)}`)
    .join('');
}

function valueToPlist(v) {
  if (typeof v === 'string')  return `<string>${escapeXml(v)}</string>`;
  if (typeof v === 'boolean') return v ? '<true/>' : '<false/>';
  if (typeof v === 'number')  return Number.isInteger(v) ? `<integer>${v}</integer>` : `<real>${v}</real>`;
  if (Array.isArray(v))       return `<array>${v.map(valueToPlist).join('')}</array>`;
  if (v && typeof v === 'object') return `<dict>${objectToPlist(v)}</dict>`;
  return `<string>${escapeXml(String(v))}</string>`;
}

/** Escape ký tự đặc biệt XML — nếu không, tên thiết bị chứa & < > sẽ hỏng plist. */
function escapeXml(s) {
  return String(s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&apos;');
}

function newUUID() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
  // fallback nếu môi trường không có crypto.randomUUID
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
}
